export default __webpack_public_path__ + "static/media/U_Uva.c3144083.svg";